import moment from 'moment';
import React from 'react';

import ClientRenderedContent from '@components/ClientRenderedContent';
import useEventTracking from '@hooks/useEventTracking';
import { event_path, events_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { UpcomingEvent } from '../../interfaces/homepage';
import { SecondaryButton } from '../Button/variants';
import { SectionTitle } from './SectionTitle';

interface UpcomingEventsProps {
  upcomingEvents: UpcomingEvent[];
}

const UpcomingEvents = ({ upcomingEvents }: UpcomingEventsProps) => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.UpcomingEvents });
  return (
    <Track>
      <div className="mb-64">
        <SectionTitle title="Upcoming Events" />
        {upcomingEvents.map(({ date, location, name, slug }, index) => (
          <div key={`${name}-${index}`} className="mb-32">
            <h2 className="my-0 font-suisse-neue text-body-md text-primary-black lg:text-subheadline-sm">
              <a
                onClickCapture={() =>
                  trackEvent(
                    click({
                      clickTarget: ClickTarget.Headline,
                      tiEventLocation: location,
                      tiEventName: name,
                    })
                  )
                }
                href={event_path(slug)}
                className="text-balance"
              >
                {name}
              </a>
            </h2>
            <p className="m-0 font-suisse-screen text-disclosure-md">
              <span className="text-primary-magenta">
                <ClientRenderedContent>
                  {moment(date).format('ddd. MMM. DD, YYYY')}
                </ClientRenderedContent>
              </span>
              <span className="mx-8 hidden text-disclosure-sm text-grayscale-gray lg:inline">
                \
              </span>
              <span className="block text-grayscale-gray lg:inline lg:text-disclosure-sm">
                {location}
              </span>
            </p>
          </div>
        ))}
        <SecondaryButton
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ViewMore }))}
          as="link"
          href={events_path()}
          className="!px-28 py-6 lg:py-12"
          fullWidth
        >
          View more
        </SecondaryButton>
      </div>
    </Track>
  );
};

export default UpcomingEvents;
